// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".accrelerate .message-code-input{border-radius:4px;text-align:left}.accrelerate .border-seprator{border-top:.5px;border-top-color:#e8e8e8;margin-bottom:1.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
